import "./Empty.css"

export default function Empty() {
  return (
    <div className="empty-container">
      <h2 className="empty">No results</h2>
    </div>
  )
}
